import { User, UserManager } from 'oidc-react'

import { IDENTITY_CONFIG, setAutomaticReauthenticationSuppressed } from '../constants/auth'
import { isShouldShowLastLoginDefined, setShouldShowLastLogin } from './last-login'

/**
 * Callback to cleanup url after login
 */
export const onSigninCallback = (_user: User | null): void => {
  setAutomaticReauthenticationSuppressed(false)

  // Cleanup query prameters from signin and leave only
  // the parameters from the shell
  const search = new URLSearchParams(window.location.search)
  if (!isShouldShowLastLoginDefined()) {
    setShouldShowLastLogin(true)
  }

  search.delete('code')
  search.delete('scope')
  search.delete('state')
  search.delete('session_state')
  search.delete('iss')

  const cleanedUrl = `${window.location.pathname}?${search.toString()}`
  window.history.replaceState({}, document.title, cleanedUrl)
}

export const createNewUser = (): UserManager => {
  return new UserManager({ ...IDENTITY_CONFIG })
}
